import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, Globe, MapPin, Heart } from 'lucide-react';

export default function Footer() {
  const handleNavClick = (e, href) => {
    // On the home page, smooth-scroll to the section. On other pages (e.g. /privacy),
    // let the browser navigate to /#section so the home page loads and jumps there.
    if (window.location.pathname === '/') {
      e.preventDefault();
      const el = document.querySelector(href);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }
  };
  const scrollTo = (id) => {
    if (window.location.pathname !== '/') {
      window.location.href = `/${id}`;
      return;
    }
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-[#2C362A] text-white py-16 px-4 sm:px-6 lg:px-8" data-testid="site-footer">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-3 gap-12">
          {/* Brand */}
          <div>
            <h2 className="font-heading text-2xl font-semibold text-white mb-1">Donna Gordon</h2>
            <p className="font-body text-sm text-[#A8B5A3] mb-4">Psychotherapist, MA</p>
            <p className="font-body text-xs text-[#708A72] leading-relaxed">
              IACP Registered Member<br />
              MA Person-Centred Counselling
            </p>
          </div>

          {/* Navigation */}
          <div>
            <p className="font-body text-xs tracking-[0.15em] uppercase text-[#708A72] mb-4">Navigation</p>
            <nav className="space-y-2">
              {[
                { label: 'Home', href: '#home' },
                { label: 'About', href: '#about' },
                { label: 'Background', href: '#background' },
                { label: 'Contact', href: '#contact' },
                { label: 'Additional Support', href: '#support' },
                { label: 'Resources', href: '#articles' },
                { label: 'Location', href: '#location' },
              ].map((link) => (
                <a
                  key={link.href}
                  href={`/${link.href}`}
                  onClick={(e) => handleNavClick(e, link.href)}
                  className="block font-body text-sm text-[#A8B5A3] hover:text-white transition-colors"
                >
                  {link.label}
                </a>
              ))}
            </nav>
          </div>

          {/* Contact */}
          <div>
            <p className="font-body text-xs tracking-[0.15em] uppercase text-[#708A72] mb-4">Contact</p>
            <div className="space-y-3">
              <a
                href="mailto:donnagordonpsychotherapy@gmail.com"
                className="flex items-center gap-2 font-body text-sm text-[#A8B5A3] hover:text-white transition-colors"
                data-testid="footer-email"
              >
                <Mail size={14} strokeWidth={1.5} className="flex-shrink-0" />
                donnagordonpsychotherapy@gmail.com
              </a>
              <a
                href="tel:+353894475225"
                className="flex items-center gap-2 font-body text-sm text-[#A8B5A3] hover:text-white transition-colors"
                data-testid="footer-phone"
              >
                <Phone size={14} strokeWidth={1.5} className="flex-shrink-0" />
                +353 89 447 5225
              </a>
              <a
                href="https://www.mynd.ie/donna-gordon"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 font-body text-sm text-[#A8B5A3] hover:text-white transition-colors"
                data-testid="footer-mynd"
              >
                <Globe size={14} strokeWidth={1.5} className="flex-shrink-0" />
                mynd.ie/donna-gordon
              </a>
              <button
                onClick={() => scrollTo('#location')}
                className="flex items-start gap-2 font-body text-sm text-[#A8B5A3] hover:text-white transition-colors text-left"
                data-testid="footer-address"
              >
                <MapPin size={14} strokeWidth={1.5} className="flex-shrink-0 mt-0.5" />
                Mynd, 5 Albert Walk, Bray, Co. Wicklow, A98 HP71
              </button>
            </div>
            <div className="mt-6">
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-[#3D4D3A] flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="font-body text-xs text-[#5B6E56]">
            &copy; Donna Gordon. All rights reserved.{' '}
            <Link
              to="/privacy"
              className="text-[#A8B5A3] hover:text-white underline underline-offset-2 hover:no-underline transition-colors"
              data-testid="footer-privacy-link"
            >
              Privacy Policy
            </Link>
          </p>
          <p className="flex items-center gap-1 font-body text-xs text-[#5B6E56]">
            Made with <Heart size={11} strokeWidth={1.5} className="text-[#708A72]" /> in Ireland
          </p>
        </div>
      </div>
    </footer>
  );
}
